import React from 'react';
import { t } from '@lingui/macro';

import NovemberFirstLogo from '../../../assets/N1_Logo.svg';

const DialogFooter = () => {
    return (
        <div className="mt-11">
            <div className="absolute left-0 bottom-0 w-full h-10 p-6 flex items-center bg-grey-100">
                {t`We collaborate with`}
                <img src={NovemberFirstLogo} alt="November First logo" className="h-2.5 ml-1.5" />
            </div>
        </div>
    );
};

export default DialogFooter;
